// extracted by css-extract-rspack-plugin
export default {"root":"root-AiAs6C"};